/* eslint-disable @typescript-eslint/no-explicit-any*/
export interface IDebounceUtilProps<T> {
    reducer(previousValue: any, currentValue: any, index: number, array: any): any[];
    stateArray?: any[];
    callback(reducedArray: any): Promise<T>;
    time: number;
}

const promiseCreator = <T>() => {
    const promiseFns = { resolve: (value: any) => {}, reject: (value: any) => {} };

    const promise = new Promise<T>((resolve, reject) => {
        promiseFns.resolve = resolve;
        promiseFns.reject = reject;
    });

    return { ...promiseFns, promise };
};

export const debounceAggregator = <T>(options: IDebounceUtilProps<T>) => {
    const { reducer, stateArray = [], callback, time } = options;

    let timeOut: any;
    let currentPromise = promiseCreator<T>();

    return (params: any = null) => {
        const { resolve, reject, promise } = currentPromise;

        stateArray.push(params);

        clearTimeout(timeOut);
        timeOut = setTimeout(() => {
            const localState = stateArray.splice(0, stateArray.length);
            currentPromise = promiseCreator();
            callback(localState.reduce(reducer, [])).then(resolve).catch(reject);
        }, time);

        return promise;
    };
};
